








































































































































































import { defineComponent, reactive, ref, toRefs } from '@vue/composition-api'
import { pagination, formatTimestamp } from '@/shared/utils'
import { textbookIssuePageLink, textbookIssuePageQrLink } from '@/shared/api'
export default defineComponent({
  name: 'TextbookIssuePagesTable',
  props: {
    textbookIssue: Object,
    loading: Boolean,
    draggedItemId: String,
    paginationPage: Number,
    itemsPerPaginationPage: Number,
    textbookIssuePages: Array,
    selectedPages: Array,
  },
  setup(props, { root, emit }) {
    const data = reactive({
      headers: [
        {
          text: 'Seitenzahl',
          value: 'page',
          sortable: false,
        },
        {
          text: 'Seitenpreview',
          value: 'preview',
          sortable: false,
        },
        {
          text: 'Medienelement-Verweise',
          value: 'occurences',
          sortable: false,
        },
        {
          text: root.$t('actions'),
          value: 'actions',
          sortable: false,
        },
      ],
    })

    const activePage = ref(null as number)

    const onMediaItemDrop = (e: DragEvent, page: number) => {
      const data = e.dataTransfer.getData('text/plain')
      emit('item-dropped', { event: e, data, page })
    }

    const onDragOver = (event: DragEvent) => {
      if (props.draggedItemId !== event.dataTransfer.getData('text/plain')) {
        return
      }
      const target = event.target
      if (!(target instanceof HTMLElement)) {
        return
      }
      const pageRow = target.closest('tr')
      activePage.value = pageRow ? parseInt(pageRow.dataset.page) : null
    }

    const onDragLeave = (event: DragEvent) => {
      if (props.draggedItemId !== event.dataTransfer.getData('text/plain')) {
        return
      }
      const target = event.target
      if (!(target instanceof HTMLElement)) {
        return
      }
      const pageRow = target.closest('tr')
      activePage.value =
        activePage.value === parseInt(pageRow.dataset.page)
          ? null
          : activePage.value
    }

    window.addEventListener(
      'dragover',
      function (e: DragEvent) {
        e.preventDefault()
      },
      false
    )
    window.addEventListener(
      'drop',
      function (e: DragEvent) {
        e.preventDefault()
      },
      false
    )

    return {
      ...toRefs(data),
      onMediaItemDrop,
      onDragOver,
      onDragLeave,
      activePage,
      pagination,
      textbookIssuePageLink,
      textbookIssuePageQrLink,
      formatTimestamp,
    }
  },
})
